import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'


import {
  faUser, faLock, faSignOutAlt, faCog, faThLarge, faBuilding, faUsers, faUniversity, faFile,
  faFileArchive, faFileExcel, faFileImage, faFilePdf, faFileWord, faFolder, faFolderOpen,
  faTimes, faCheckSquare, faPlus, faEnvelope, faEdit, faArrowUp, faStop, faSearch, faDownload
} from '@fortawesome/free-solid-svg-icons'


library.add(
    faUser, faLock, faSignOutAlt, faCog, faThLarge, faBuilding, faUsers, faUniversity, faFile,
    faFileArchive, faFileExcel, faFileImage, faFilePdf, faFileWord, faFolder, faFolderOpen,
    faTimes, faCheckSquare, faPlus, faEnvelope, faEdit, faArrowUp, faStop, faSearch, faDownload
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/fontawesome.js